module.exports = __webpack_public_path__ + "static/img/yzh.eeaa64c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/yzh.jpg
// module id = qRuP
// module chunks = 0